function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { FilterIds } from 'swag-common/constants/main-swag.constants';
import { Toggle } from '../../../../../../../components/ui/toggle';
import classes from './styles.scss';
const toggleClasses = {
  faceClassName: classes.toggleFace,
  labelClassName: classes.toggleLabel,
  toggleClassName: classes.toggleToggle,
  wrapperClassName: classes.toggleWrapper,
  checkLabelClassName: classes.toggleCheckLabel
};
export const BoxAndInventoryComponent = ({
  color = '',
  isDisabled,
  isAvailableSuperSpeed,
  filters: {
    isBox,
    isInventory,
    isSuperSpeed
  },
  onForBoxChange,
  onInventoryChange,
  onSuperSpeedChange
}) => {
  const onToggle = id => () => {
    if (isDisabled) {
      return null;
    }
    switch (id) {
      case FilterIds.isBox:
        {
          return !isSuperSpeed && onForBoxChange(!isBox);
        }
      case FilterIds.isInventory:
        {
          return onInventoryChange(!isInventory);
        }
      case FilterIds.isSuperSpeed:
        {
          return onSuperSpeedChange(!isSuperSpeed);
        }
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Toggle, _extends({}, toggleClasses, {
    value: isInventory,
    onToggle: onToggle(FilterIds.isInventory),
    uncheckedLabel: "Only products that can be added to inventory",
    color: color
  })), /*#__PURE__*/React.createElement(Toggle, _extends({}, toggleClasses, {
    toggleClassName: isSuperSpeed ? classes.disabledToggle : classes.toggleToggle,
    value: isBox,
    onToggle: onToggle(FilterIds.isBox),
    uncheckedLabel: "Only products that can be added to box",
    color: color
  })), isAvailableSuperSpeed && /*#__PURE__*/React.createElement(Toggle, _extends({}, toggleClasses, {
    toggleBackgroundClassName: classes.superSpeedToggle,
    value: isSuperSpeed,
    onToggle: onToggle(FilterIds.isSuperSpeed),
    uncheckedLabel: "Boxes created in under 15 business days (Super Speed)",
    color: color
  })));
};